module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_sns_05-5d11dfd8bf6ef03ea6a24a1117a84238.jpg";